import { useInitProvider } from 'providers/InitProvider';
import ProfileView from './Profile.view';
import { useNotificationsContext } from 'providers/NotificationsProvider';
import { Progress } from 'components/Progress';

const ProfileContainer = () => {
  const { dump } = useInitProvider();
  const { notifications, counter } = useNotificationsContext();

  if (!dump.user) return <Progress />;

  return (
    <div>
      {/* <button onClick={() => sendMessage('ciao Mr. Green')}>send msg</button> */}
      <ProfileView
        notifications={notifications}
        counter={counter}
        user={dump.user}
      />
    </div>
  );
};

export default ProfileContainer;
